module.exports = __webpack_public_path__ + "img/frame (100).2c70abb6.jpg";